import React, { useState, useEffect, useRef } from 'react';
import { Badge, Icon, Popover } from 'antd';
import { useQueryClient } from 'react-query';
import cn from 'classnames';
import { notificationsQuery } from './shared/queries';
import { notificationsQueryParams as params } from './shared/constants';
import { HasContent } from './containers/hasContent';
import EmptyContent from './shared/ui/EmptyContent';
import { createNotificationsKey } from './shared/queries/notifications';
import styles from './Notifications.module.scss';

const { useNotifications, createNotificationsWithModes } = notificationsQuery;

const Notifications = ({ className }) => {
  const [visible, setVisible] = useState(false);
  const [renderContent, setRenderContent] = useState(visible);

  const { data } = useNotifications(params, {
    staleTime: 1000 * 60,
    refetchInterval: 1000 * 60,
    refetchIntervalInBackground: true,
    select: createNotificationsWithModes,
  });

  const timeoutRef = useRef(null);

  const handleVisibleChange = (visible) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setRenderContent(visible);
    }, 0);

    setVisible(visible);
  };

  const queryClient = useQueryClient();

  useEffect(() => {
    return () => queryClient.resetQueries(createNotificationsKey());
  }, []);

  return (
    <Popover
      visible={visible}
      placement="bottom"
      content={
        !renderContent ? null : data ? (
          <HasContent data={data} onSourceClick={() => setVisible(false)} />
        ) : (
          <EmptyContent />
        )
      }
      trigger="click"
      overlayClassName={styles.overlay}
      onVisibleChange={handleVisibleChange}
    >
      <Badge
        count={data?.unreadCount ?? 0}
        offset={[-2, 4]}
        className={cn(styles.badge, className)}
      >
        <Icon type="bell" className={styles.icon} />
      </Badge>
    </Popover>
  );
};

export default Notifications;
